import Utils from "./utils";
import Verge from 'verge';
import $ from "jquery";

/**
 *
 */
class ContactMap {

	/**
	 *
	 * @param options
	 */
	constructor(){

		Utils.debug('Construct Contact map');
		if($('.contact__map').length > 0) {
			this.init();
		}
	}

	init() {
		$('.contact__map').each(function () {
			let coords = $(this).data('coords').split(',');
			let iconUrl =  $(this).data('icon');
			let zoom = $(this).data('zoom');
			let myLatLng = { lat: parseFloat(coords[0]), lng: parseFloat(coords[1]) };
			let map = new google.maps.Map(this, {
				center: myLatLng,
				zoom: parseInt(zoom),
				disableDefaultUI: true,
			});

			let marker = new google.maps.Marker({
				position: myLatLng,
				map,
				icon: {
					url: iconUrl,
					labelOrigin: new google.maps.Point(parseInt(coords[2]),  parseInt(coords[3]))
				},
				label: {
					color: 'red',
					fontSize: '11px',
					fontWeight: '600',
					text: '280 Rue Helene boucher'
				}
			});

			map.panBy(-Math.floor(map.getDiv().offsetWidth/5),map.getDiv().offsetHeight/5)
		})

	}
}


module.exports = ContactMap;
